import Inventory from './Inventory'
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import InventoryView from "./view/InventoryView";
import DashboardView from "./view/dashboard/DashboardView";
import Notes from "./view/notes/Notes";
import Images from "./view/images/Images";
import ActivitiesView from "./view/activities/ActivitiesView";
import Attachments from "@/modules/inventory/view/attachments/Attachments";
import LotsList from "@/modules/inventory/view/lots/LotsList";
import InventoryList from "@/modules/inventory/view/source-inventories/InventoryList";
import ConditionReports from "@/modules/inventory/view/condition-reports/ConditionReports.vue";
import ConditionReportRequests from "@/modules/inventory/view/condition-report-requests/ConditionReportRequests.vue";
import Terms from "@/modules/inventory/view/terms/Terms";
import VendorCharges from "./view/vendor-charges/VendorCharges";
import MovementHistoryView from "./view/movement-history/MovementHistoryView";

let routes = [
  {
    path: 'inventory',
    name: 'inventory',
    component: Inventory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'inventory/view/:id',
    component: InventoryView,
    name: 'inventory.view',
    redirect: 'inventory/view/:id/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'inventory.dashboard',
        component: DashboardView
      }, {
        path: 'images',
        name: 'inventory.images',
        component: Images,
        props: (route) => ({inventoryUuid: route.params.id})
      }, {
        path: 'notes',
        name: 'inventory.notes',
        component: Notes
      },
      {
        path: 'condition-reports',
        name: 'inventory.conditionReports',
        component: ConditionReports
      },
      {
        path: 'condition-report-requests',
        name: 'inventory.conditionReportRequests',
        component: ConditionReportRequests
      },
      {
        path: 'attachments',
        name: 'inventory.attachments',
        component: Attachments
      },
      {
        path: 'activities',
        name: 'inventory.activities',
        component: ActivitiesView
      },
      {
        path: 'movement-history',
        name: 'inventory.movementHistory',
        component: MovementHistoryView
      },
      {
        path: 'reservations',
        name: 'inventory.reservations',
        component: LotsList
      },
      {
        path: 'items',
        name: 'inventory.sourceInventories',
        component: InventoryList
      },
      {
        path: 'terms',
        name: 'inventory.terms',
        component: Terms
      },
      {
        path: 'vendorCharges',
        name: 'inventory.vendorCharges',
        component: VendorCharges
      },
    ]
  },
];

export default {
  menuItem: new MenuItem('/inventory', i18n.t('Inventory'), 40, 'box', [], 'view_inventoryitem'),
  routes: routes
}
